// Mock data for TGS Landing Page

export const events = [
  {
    id: 1,
    title: "Business x Engineering Networking Night",
    date: "March 15, 2025",
    time: "6:00 PM - 9:00 PM",
    location: "Desmarais Hall, Room 2101",
    description: "Connect with engineering students and industry professionals. Learn about opportunities in project management, operations, and technical consulting.",
    attendees: 85,
    spotsLeft: 15
  },
  {
    id: 2,
    title: "Pharma & Biotech Career Panel",
    date: "March 28, 2025",
    time: "5:30 PM - 7:30 PM",
    location: "Telfer Building, Amphitheatre",
    description: "Meet recruiters from leading pharmaceutical and biotech companies. Discover business roles in science-driven industries.",
    attendees: 62,
    spotsLeft: 38
  },
  {
    id: 3,
    title: "Corporate Law & Policy Workshop",
    date: "April 10, 2025",
    time: "4:00 PM - 6:00 PM",
    location: "Faculty of Law, Fauteux Hall",
    description: "Explore the intersection of business and law. Network with legal professionals and learn about compliance, policy, and corporate roles.",
    attendees: 45,
    spotsLeft: 25
  }
];

export const industries = [
  {
    id: 1,
    name: "Engineering",
    icon: "Cog",
    description: "Project management, operations, finance roles in engineering firms. Business minds driving technical innovation.",
    opportunities: ["Project Management", "Operations Strategy", "Technical Consulting", "Business Development"],
    color: "from-red-50 to-orange-50"
  },
  {
    id: 2,
    name: "Science & Healthcare",
    icon: "Microscope",
    description: "Pharma, biotech, and research organizations need business expertise. From operations to regulatory affairs.",
    opportunities: ["Pharmaceutical Operations", "Biotech Finance", "Healthcare Consulting", "Regulatory Affairs"],
    color: "from-blue-50 to-cyan-50"
  },
  {
    id: 3,
    name: "Law & Policy",
    icon: "Scale",
    description: "Corporate law, government policy, and compliance sectors value business acumen alongside legal expertise.",
    opportunities: ["Corporate Compliance", "Policy Analysis", "Legal Operations", "Risk Management"],
    color: "from-slate-50 to-gray-50"
  }
];

export const stats = [
  { label: "Cross-Faculty Events", value: "15+", icon: "Users" },
  { label: "Industry Partners", value: "30+", icon: "Briefcase" },
  { label: "Active Members", value: "200+", icon: "UserPlus" },
  { label: "Career Connections", value: "500+", icon: "TrendingUp" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    program: "BCom, 3rd Year",
    quote: "TGS opened my eyes to opportunities I never knew existed. I'm now interning at an aerospace engineering firm in their operations department.",
    avatar: "SC"
  },
  {
    id: 2,
    name: "Marcus Thompson",
    program: "BCom, 4th Year",
    quote: "The biotech networking event connected me with recruiters I would never have met through traditional business clubs. Game changer.",
    avatar: "MT"
  },
  {
    id: 3,
    name: "Priya Sharma",
    program: "BCom, 2nd Year",
    quote: "Finally, a club that shows business students we're not limited to banks and consulting firms. The possibilities are endless.",
    avatar: "PS"
  }
];
